import { useState } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useLazyGetConceptGroupConceptsDetailsQuery } from '@verantos-dev/data-access-concept-groups';
import { exportToCsv } from '@verantos-dev/shared-components';

export const useExportConceptGroup = ({
  conceptGroupId,
  conceptGroupName,
}: {
  conceptGroupId: string;
  conceptGroupName: string;
}) => {
  const [getConceptsData] = useLazyGetConceptGroupConceptsDetailsQuery();
  const [exporting, setExporting] = useState(false);

  // Handler to fetch all data and export
  const handleExportAll = async () => {
    setExporting(true);
    try {
      const { data: allRows } = await getConceptsData({
        conceptGroupId,
        searchParams: '?pageSize=-1',
      });

      exportToCsv(`${conceptGroupName}-${conceptGroupId}.csv`, allRows?.data || [], [
        {
          field: 'conceptId',
          headerName: 'concept_id',
        },
        {
          field: 'conceptName',
          headerName: 'concept_name',
        },
        {
          field: 'vocabularyId',
          headerName: 'vocabulary_id',
        },
        {
          field: 'conceptCode',
          headerName: 'concept_code',
        },
        {
          field: 'domainId',
          headerName: 'domain_id',
        },
      ]);
    } catch (e) {
      // Optionally show error
      console.error('Export failed', e);
    } finally {
      setExporting(false);
    }
  };

  return { exporting, handleExportAll };
};
